import * as angular from 'angular';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsCommands} from "../../shared/dto/aps.commands";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface CheckDetectorDefectMappingService {
  getCheckDetectorDefectMappings(): angular.IPromise<apsViewModels.CheckDetectorDefectMappingItem[]>;
  addCheckDetectorDefectMapping(command: apsCommands.AddCheckDetectorDefectMapping): angular.IPromise<any>;
  updateCheckDetectorDefectMapping(command: apsCommands.UpdateCheckDetectorDefectMapping): angular.IPromise<any>;
}

class CheckDetectorDefectMappingSvc implements CheckDetectorDefectMappingService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  getCheckDetectorDefectMappings (): angular.IPromise<apsViewModels.CheckDetectorDefectMappingItem[]> {
    return (this.httpService.get<apsViewModels.CheckDetectorDefectMappingItem[]>(Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS)
    );
  };

  addCheckDetectorDefectMapping(command: apsCommands.AddCheckDetectorDefectMapping): angular.IPromise<any> {
    return this.httpService.put<any>(Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS, command);
  };

  updateCheckDetectorDefectMapping(command: apsCommands.UpdateCheckDetectorDefectMapping): angular.IPromise<any> {
    return this.httpService.post<any>(Endpoints.CHECK_DETECTOR_DEFECT_MAPPINGS, command);
  };
}

export default angular
  .module('aps.services.checkDetector', [HttpServiceName])
  .service('checkDetectorDefectMappingService', CheckDetectorDefectMappingSvc)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/checkDetectorDefectMapping/checkDetectorDefectMapping.service.ts